<template>
  <div class="shop-inner-content">
    <div class="shop-inner-padding-content">
      <div class="photo-content col-12 col-lg-6 mb-md-5 mb-3">
        <Photo />
      </div>
      <div class="info-content col-12 col-lg-6 mb-md-5">
        <SpecFood v-if="dataIsLoad && pattern == 2" />
        <Spec v-if="dataIsLoad && pattern == 1" />
      </div>
      <div class="col-12">
        <DescriptionFood v-if="pattern == 2" />
        <DescriptionClothes v-else />
      </div>
    </div>
    <div class="w-100">
      <Recommend />
    </div>
    <SpecMobileFood v-if="pattern == 2" />
    <SpecMobile v-else />
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { storeToRefs } from 'pinia';

import useShopContentStore from '@global/stores/useShopContentStore';

import Photo from '@page/shopContent/components/Photo.vue';
import Recommend from '@page/shopContent/components/Recommend.vue';
import DescriptionFood from '@page/shopContent/components/DescriptionFood.vue';
import DescriptionClothes from '@page/shopContent/components/DescriptionClothes.vue';
import SpecFood from '@page/shopContent/components/SpecFood.vue';
import Spec from '@page/shopContent/components/Spec.vue';
import SpecMobileFood from '@page/shopContent/components/SpecMobileFood.vue';
import SpecMobile from '@page/shopContent/components/SpecMobile.vue';

import { fireShopContentView } from '@global/gtm/product';

const shopContentStore = useShopContentStore();
const { itemDatas, selectedDataID, selectedData, dataIsLoad } = storeToRefs(shopContentStore);
const { getData, getSelectedData, getRecommendData } = shopContentStore;
const pattern = window.Pattern;

watch(selectedDataID, (nV) => {
  console.log(nV);

  getSelectedData();

  fireShopContentView({
    affiliation: selectedData.value.Name,
    customMarketID: itemDatas.value.CustomMarketID,
    eventName: itemDatas.value.Events.length ? itemDatas.value.Events[0].Name : '',
    name: itemDatas.value.Name,
    price: itemDatas.value.EventPrice > 0 ? itemDatas.value.EventPrice : itemDatas.value.SellPrice,
  });
});

getData();
getRecommendData();
</script>
